import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg, getToken } from "@/lib/api";
import { Header } from "@/components/SiteLayout";
import Registration from "@/components/mapa/Registration";
import Questionnaire from "@/components/mapa/Questionnaire";
import ReportView from "@/components/mapa/ReportView";
import Interlude, { seen } from "@/components/mapa/Interlude";
import { JOURNEY } from "@/config/content";

const NoAccess = ({ msg }) => (
  <div className="mx-auto max-w-lg px-5 py-20 text-center" data-testid="no-access">
    <h1 className="text-3xl text-stone-900">Acesso necessário</h1>
    <p className="mt-4 text-stone-600">{msg}</p>
    <div className="mt-8 flex flex-col items-center gap-3">
      <Link to="/recuperar-acesso" className="btn-primary" data-testid="no-access-recover-link">Recuperar meu acesso</Link>
      <Link to="/" className="btn-ghost">Conhecer o Mapa da Virada</Link>
    </div>
  </div>
);

export default function MapaPage() {
  const [session, setSession] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [, refresh] = useState(0);

  const load = useCallback(async () => {
    if (!getToken()) {
      setError("Use o link individual enviado ao seu e-mail após a confirmação do pagamento.");
      return;
    }
    try {
      const [s, q] = await Promise.all([api.get("/session"), api.get("/questionnaire")]);
      setSession(s.data);
      setData(q.data);
    } catch (e) {
      setError(errMsg(e));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  let body = <div className="p-16 text-center text-stone-500" data-testid="mapa-loading">Carregando…</div>;
  if (error) body = <NoAccess msg={error} />;
  else if (session && data) {
    if (!session.profile) {
      body = seen.has("intro")
        ? <Registration session={session} options={data.registration_options} onDone={setSession} />
        : <Interlude id="intro" {...JOURNEY.intro} onNext={() => { seen.add("intro"); refresh((n) => n + 1); }} />;
    }
    else if (!session.completed) body = <Questionnaire session={session} data={data} onSession={setSession} />;
    else body = <ReportView />;
  }
  return (
    <div className="grain min-h-screen">
      <Header />
      <main className="relative z-10">{body}</main>
    </div>
  );
}
